import { authenticationTypes } from 'root/src/shared/constants/auth';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
// every array/string length is limited because we're directly
// saving that in db and options can be passed quite freely
export const submitSatisfactionSurveyEndpoint = {
    [surveyEndpointIds.SUBMIT_SATISFACTION_SURVEY]: {
        authentication: authenticationTypes.optional,
        payloadSchema: {
            type: 'object',
            properties: {
                answers: {
                    type: 'array',
                    maxItems: 20,
                    items: {
                        type: 'object',
                        properties: {
                            questionType: {
                                type: 'string',
                                maxLength: 100,
                            },
                            question: {
                                type: 'string',
                                maxLength: 200,
                            },
                            options: {
                                type: 'array',
                                maxItems: 20,
                                items: {
                                    type: 'string',
                                    maxLength: 1000,
                                },
                            },
                            answer: {
                                anyOf: [
                                    {
                                        type: 'array',
                                        maxItems: 20,
                                        items: {
                                            type: 'string',
                                            maxLength: 1000,
                                        },
                                    },
                                    {
                                        type: 'string',
                                        maxLength: 1000,
                                    },
                                ],
                            },
                        },
                        required: ['questionType', 'question'],
                    },
                },
            },
            required: ['answers'],
        },
    },
};
